import React from "react";
import { styled } from "styled-components";
import { Colors } from "../../ColorConstants";
import Button from "../Buttons";
import { Text } from "../../TextConstants";
import { AquaDefault } from "../../assets/images";

const AquaGames = ({ data,onBook }) => {
  return (
    <GamesValueWrapper>
      {Object.keys(data)?.map((key) => (
        <GamesContainer>
          <GamesTitleDiv>
            <GamesTitle>{key}</GamesTitle>
          </GamesTitleDiv>
          <GameInfoMainContainer>
            {data[key].map((value) => (
              <GameInfoDiv>
                <GameImgContainer>
                  <GameImg src={value?.imageUrl || AquaDefault} />
                </GameImgContainer>
                <GameInfoSubContainer>
                  <GameSubTitle>{value?.name}</GameSubTitle>
                  <GameRiderInfo>{value?.specialInfo}</GameRiderInfo>
                  {/* {value?.description?.length > 25 && (
                    <div className="tooltip">{value?.description}</div>
                  )} */}
                </GameInfoSubContainer>
                <CostContainer>
                  {value?.aquaPrice.map((priceList) => (
                    <Cost>{`${priceList?.duration} Min ${priceList.price}QAR`}</Cost>
                  ))}
                </CostContainer>
                <ButtonContainer>
                  <Button
                    label={Text.book}
                    variant="filled"
                    padding="0.5rem 1rem"
                    width="150px"
                    onClick={() => onBook(value)}
                  />
                </ButtonContainer>
              </GameInfoDiv>
            ))}
          </GameInfoMainContainer>
        </GamesContainer>
      ))}
    </GamesValueWrapper>
  );
};

const GamesValueWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 4rem;
  // border: 1px solid black;
  justify-content: center;
  @media only screen and (max-width: 1024px) {
    margin-top: 2rem;
  }
`;
const GamesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-bottom: 2rem;
  // border: 1px solid blue;
  // width: 40%;
  // @media only screen and (max-width: 912px) {
  //   width: 100%;
  // }
  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;
const GamesTitleDiv = styled.div`
  display: flex;
  background-color: ${Colors.lightBlack4};
  padding: 0.3rem 1rem;
  justify-content: center;
`;
const GameInfoMainContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  // border: 1px solid red;
  gap: 1rem;
  justify-content: center;
  @media only screen and (max-width: 768px) {
    justify-content: space-around;
  }
  @media only screen and (max-width: 480px) {
    flex-direction: column;
    flex-wrap: none;
    gap: 0rem;
  }
`;
const GamesTitle = styled.span`
  color: ${Colors.white};
  text-align: center;
  font-size: 1.8rem;
  font-style: italic;
`;
const GameInfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0.2rem;
  @media only screen and (max-width: 768px) {
    // padding: 1rem 1rem;
  }
`;
const GameImg = styled.img`
  object-fit: contain;
  width: 8rem;
`;

const GameImgContainer = styled.div`
  width: 100%;
  height: 8rem;
  display: flex;
  justify-content: center;
`;
const GameInfoSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  align-items: center;
  position: relative;
  // border: 1px solid blue;
  cursor: pointer;

  .tooltip {
    position: absolute;
    top: 50%;
    left: 50%;
    // transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    opacity: 0;
    transition: opacity 0.3s;
    // white-space: nowrap;
    pointer-events: none;
    cursor: pointer;
    // border: 1px solid red;
    width: 120%;
    z-index: 1000;
  }
  &:hover .tooltip {
    opacity: 1;
  }
`;
const GameSubTitle = styled.span`
  color: ${Colors.black};
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  @media only screen and (max-width: 768px) {
    font-size: 1rem;
  }
`;
const GameRiderInfo = styled.span`
  color: ${Colors.aquaGreen};
  text-align: center;
  font-size: 1rem;
  font-style: italic;
  font-weight: 600;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media only screen and (max-width: 768px) {
    font-size: 0.8rem;
  }
  @media only screen and (max-width: 500px) {
    width: 150px;
  }
`;
const CostContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`;
const ButtonContainer = styled.div`
  margin-top: 1rem;
  // width: 80%;
`;
const Cost = styled.span`
  color: ${Colors.black};
  text-align: center;
  font-size: 1rem;
  font-weight: 500;
  @media only screen and (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

export default AquaGames;
